import React from "react";
import { Col } from "react-bootstrap";
import DashboardNewListIndustriesTabContainer from "./industries-container";
import DashboardNewListLocationTabContainer from "./location-container";
import DashboardNewListOrganizationTabContainer from "./organization-container";
import TabSelector from "../../../library/tab-selector";
import { UpperRow } from "../../../library/upper-row";
import "./style.scss";

const Index = () => {
  const selectionRabs = [
    {
      key: "industry",
      title: "Næring",
      content: <DashboardNewListIndustriesTabContainer />,
    },
    {
      key: "location",
      title: "Sted",
      content: <DashboardNewListLocationTabContainer />,
    },
    {
      key: "organization",
      title: "Organisasjon",
      content: <DashboardNewListOrganizationTabContainer />,
    },
  ];

  return (
    <Col md={7} className="dashboard-new-list-left-container">
      <Col className="inner-dashboard-new-list-left-container">
        <UpperRow title="Ny liste" />
        <TabSelector defaultValue="industry" items={selectionRabs} />
      </Col>
    </Col>
  );
};

export default Index;
